import { Link } from "react-router-dom";
import Logo from "../logo-removebg-preview.png";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <img src={Logo} alt="Logo" className="h-16 mx-auto mb-8" />
        <h1 className="text-9xl font-bold text-indigo-600 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">صفحه مورد نظر یافت نشد</h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          متاسفانه صفحه‌ای که به دنبال آن هستید وجود ندارد یا منتقل شده است.
        </p>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          بازگشت به صفحه اصلی
        </Link>
      </div>
    </div>
  );
} 